import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PressHero from './components/PressHero';
import PressReleases from './components/PressReleases';
import MediaCoverage from './components/MediaCoverage';
import PressKit from './components/PressKit';
import PressContact from './components/PressContact';

export default function PressPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://track-verse.com';

  useEffect(() => {
    document.title = 'Presse & Médias TrackVerse — Communiqués & Actualités Logistique';
    document.documentElement.lang = 'fr';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Salle de presse TrackVerse : dernières actualités, communiqués de presse, couverture médiatique et kit presse. Contactez notre équipe médias pour interviews et informations entreprise.');
    setMeta('keywords', 'presse TrackVerse, communiqués presse, actualités logistique, couverture médias, annonces entreprise');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); (canonical as HTMLLinkElement).rel = 'canonical'; document.head.appendChild(canonical); }
    (canonical as HTMLLinkElement).href = `${siteUrl}/press`;

    setMeta('og:title', 'Presse & Médias TrackVerse — Actualités Logistique', true);
    setMeta('og:description', 'Communiqués de presse, couverture médiatique et kit presse TrackVerse.', true);
    setMeta('og:url', `${siteUrl}/press`, true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', `${siteUrl}/og-image.jpg`, true);
    setMeta('twitter:title', 'Presse & Médias TrackVerse');
    setMeta('twitter:description', 'Communiqués de presse et actualités logistique TrackVerse.');
    setMeta('twitter:image', `${siteUrl}/og-image.jpg`);

    const pressSchema = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Presse & Médias TrackVerse",
      "url": `${siteUrl}/press`,
      "description": "Dernières actualités, communiqués de presse et couverture médiatique de TrackVerse",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Accueil", "item": `${siteUrl}/` },
          { "@type": "ListItem", "position": 2, "name": "Presse", "item": `${siteUrl}/press` }
        ]
      },
      "publisher": {
        "@type": "Organization",
        "name": "TrackVerse",
        "logo": { "@type": "ImageObject", "url": `${siteUrl}/logo.png` },
        "url": siteUrl
      }
    };

    let script = document.querySelector('script[data-schema="press"]');
    if (!script) { script = document.createElement('script'); script.setAttribute('type', 'application/ld+json'); script.setAttribute('data-schema', 'press'); document.head.appendChild(script); }
    script.textContent = JSON.stringify(pressSchema);

    return () => { const s = document.querySelector('script[data-schema="press"]'); if (s) s.remove(); };
  }, [siteUrl]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PressHero />
      <PressReleases />
      <MediaCoverage />
      <PressKit />
      <PressContact />
      <Footer />
    </div>
  );
}
